// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","279":"component---src-pages-index-jsx"}[chunkId] + "-" + {"125":"4e62d0fa0b640a1fdbb8","279":"53b4ee7161ef0a42b825"}[chunkId] + ".js";
};